import React from 'react'
import { Modal } from 'react-bootstrap'

export default class modalTambah extends React.Component {
    render() {
        const { ShowModalDel, CancelHandler, DeleteHandler2, Model } = this.props

        return (
            <div>
                <Modal show={ShowModalDel} onHide={CancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>BATALKAN RENCANA KEDATANGAN</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Anda yakin ingin membatalkan rencana kedatangan berikut? <br /> <br />
                            <p>
                                <span class="error ml-5"> {Model.nama_pasien}</span> <br />
                                <span class="ml-5">{Model.date} {Model.month} {Model.year}, {Model.medical_facility}</span> <br />
                                <span class="ml-5">{Model.nama_dokter}, - {Model.treatment}</span>
                            </p>
                        </p>

                    </Modal.Body>

                    <Modal.Footer>
                        <button type="button" class="btn btn-light" onClick={CancelHandler}>Tidak</button>
                        <button class="btn btn-danger" onClick={() => DeleteHandler2()}>Yakin</button>


                    </Modal.Footer>
                </Modal>

            </div>
        )
    }
}